// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3vzFb","label":"CategoryService_label__eRRxM","location":"CategoryService_location__1tTwa"};